// Los textos con los que el chat explica qué está pasando: qué proveedor usa, por qué tarda y qué hacer si falla.
// Son funciones puras para poder probarlas sin dibujar la pantalla.

export const PROVIDER_LABELS = {
  ANTHROPIC: 'Claude', GEMINI: 'Gemini', GROQ: 'Groq', OPENAI: 'OpenAI', MISTRAL: 'Mistral', OPENROUTER: 'OpenRouter',
};

export const providerLabel = (key) => PROVIDER_LABELS[key] || key || 'el proveedor';

/** Segundos de espera a partir de los cuales se ofrece cancelar. */
export const CANCEL_AFTER_SECONDS = 15;

const SLOW_AFTER_SECONDS = 15;
const VERY_SLOW_AFTER_SECONDS = 45;

/** Lo que dice el chat mientras espera la respuesta, según cuánto lleva esperando. */
export const waitingHint = (seconds, provider) => {
  const name = providerLabel(provider);
  if (seconds < SLOW_AFTER_SECONDS) return 'Consultando tus datos…';
  if (seconds < VERY_SLOW_AFTER_SECONDS) return `Está tardando más de lo habitual. ${name} puede estar con mucha demanda…`;
  return `${name} sigue sin responder. Podés seguir esperando, o cancelar y probar con otro modelo.`;
};

/**
 * Qué sugerir cuando una pregunta falló. `kind` es el tipo de error que manda el backend (`error_kind`).
 * Devuelve el texto a mostrar y qué botones ofrecer: reintentar y/o ir a Configuración (solo a quien puede administrarla).
 */
export const errorAdvice = (kind, canManage) => {
  switch (kind) {
    case 'INVALID_KEY':
      return {
        text: canManage ? 'Revisá la clave de API en Configuración.' : 'Pedile a quien administra la empresa que revise la clave de API.',
        retry: false,
        settings: canManage,
      };
    case 'NOT_CONFIGURED':
      return {
        text: canManage ? 'Cargá la clave de API en Configuración.' : 'Pedile a quien administra la empresa que cargue la clave de API.',
        retry: false,
        settings: canManage,
      };
    case 'PROVIDER_UNAVAILABLE':
    case 'TIMEOUT':
      return {
        text: canManage
          ? 'Suele ser pasajero. Podés reintentar, o probar otro modelo en Configuración.'
          : 'Suele ser pasajero. Podés reintentar en un momento.',
        retry: true,
        settings: canManage,
      };
    case 'PROVIDER_REJECTED':
      return {
        text: canManage ? 'Si el mensaje menciona el modelo, probá con otro en Configuración.' : null,
        retry: false,
        settings: canManage,
      };
    case 'RATE_LIMITED':
      return { text: 'Esperá un momento antes de volver a preguntar.', retry: true, settings: false };
    case 'CANCELED':
      return { text: null, retry: true, settings: false };
    default:
      return { text: null, retry: true, settings: false };
  }
};
